import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import Button from "../../../components/common/Button";
import { Col, Container, Row, Spinner, Image, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { getAppAction } from "../../opsUser/ppApplication/ppIndia/redux/action/getAppAction";
import { useParams } from "react-router-dom";
import { getSessionId, getUserRole } from "../../../utils/tokenHandlers";
import axios from "axios";
import { error } from "console";
import SectionHeading from "../../../components/common/SectionHeading";
import RadioButton from "../../../components/common/RadioButton";
import { otherDocsType } from "../redux/types/VerificationDetailsType";
import Input from "../../../components/common/Input";
import { updateAppAction } from "../../opsUser/ppApplication/ppIndia/redux/action/updateAppAction";
import { BusinessDetailsType } from "../../opsUser/ppApplication/ppIndia/pages/types/BusinessDetailsType";
import { DisplayBox } from "../../../components/containers/DisplayBox";
import AlertPopup from "../../../components/common/Alert/AlertPopup";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

const OtherDocsVerification: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  let { appId } = useParams();
  let customerId = Number(appId);
  const userRole = getUserRole();
  const sessionId = getSessionId();
  const [imageData, setImageData] = useState("");
  const [fileType, setFileType] = useState("");
  const [titleText, setTitleText] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [submitSpinner, setSubmitSpinner] = useState(false);
  const [MAClicked, setMAClicked] = useState(false);
  const [SAClicked, setSAClicked] = useState(false);
  const [makerVerStatus, setMakerVerStatus] = useState("");
  const [checkerVerStatus, setCheckerVerStatus] = useState("");
  const [showSaveAlert, setShowSaveAlert] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<BusinessDetailsType>({
    shouldUnregister: true,
  });

  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp,
  );
  const appStage = getAppSelector.data.stage;
  const isCounterParty = getAppSelector.data.is_counterparty;
  const handleMasterAgreementClick = async () => {
    setMAClicked(true);
    setSAClicked(false);

    const docId = getAppSelector.data.master_agreeement_attachment_ids[0];
    const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;
    const sessionId = getSessionId();

    try {
      setTitleText("Master Agreement :");
      setShowSpinner(true);

      const UidEmailRole = UidEmailRoleMatch();

      const response = await axios.post(
        apiUrl,
        {
          params: {
            ...UidEmailRole,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        },
      );
      // const dataAsArray = new Uint8Array(response.data);

      // if (
      //   dataAsArray[0] === 0x25 &&
      //   dataAsArray[1] === 0x50 &&
      //   dataAsArray[2] === 0x44 &&
      //   dataAsArray[3] === 0x46
      // ) {
      //   setImageData(apiUrl);
      //   setFileType("pdf");
      const fileString: string = response.data.result;

      // Convert string to Uint8Array (binary data)
      const dataAsArray = new TextEncoder().encode(fileString);

      // Check if it’s PDF
      if (fileString.startsWith("%PDF")) {
        // Convert string → binary array (safe for older TS targets)
        const byteArray = new Uint8Array(fileString.length);
        for (let i = 0; i < fileString.length; i++) {
          byteArray[i] = fileString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setImageData(blobUrl);
        setFileType("pdf");
      } else {
        // Assume it's image → convert to Base64
        const base64Data = btoa(fileString);
        const imageBase64 = `data:image/png;base64,${base64Data}`;
        setImageData(imageBase64);
        setFileType("img");
      }
    } catch (error) {
      setTitleText("Master Agreement not uploaded!");
      setImageData("");
      // Optionally: console.error("Error fetching file:", error);
    } finally {
      setShowSpinner(false);
    }
  };

  // Similarly, update handleSignedAppClick
  const handleSignedAppClick = async () => {
    setSAClicked(true);
    setMAClicked(false);

    const docId = getAppSelector.data.signed_application_form_attachment_ids[0];
    const sessionId = getSessionId();
    const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;

    try {
      setTitleText("Signed Application :");
      setShowSpinner(true);
      const UidEmailRole = UidEmailRoleMatch();

      const response = await axios.post(
        apiUrl,
        {
          params: {
            ...UidEmailRole,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        },
      );

      // ✅ Extract file string from response
      const fileString: string = response.data.result;

      // Convert string to Uint8Array (binary data)
      const dataAsArray = new TextEncoder().encode(fileString);

      // Check if it’s PDF
      if (fileString.startsWith("%PDF")) {
        // Convert string → binary array (safe for older TS targets)
        const byteArray = new Uint8Array(fileString.length);
        for (let i = 0; i < fileString.length; i++) {
          byteArray[i] = fileString.charCodeAt(i);
        }

        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        setImageData(blobUrl);
        setFileType("pdf");
      } else {
        // Assume it's image → convert to Base64
        const base64Data = btoa(fileString);
        const imageBase64 = `data:image/png;base64,${base64Data}`;
        setImageData(imageBase64);
        setFileType("img");
      }
    } catch (error) {
      setTitleText("Signed Application Form not uploaded!");
      setImageData("");
    } finally {
      setShowSpinner(false);
    }
  };

  useEffect(() => {
    dispatch(getAppAction(customerId));
  }, []);

  useEffect(() => {
    reset({
      mk_signed_application_form_attachment_status:
        getAppSelector.data.mk_signed_application_form_attachment_status,
      mk_signed_application_form_attachment_comments:
        getAppSelector.data.mk_signed_application_form_attachment_comments,
      ck_signed_application_form_attachment_status:
        getAppSelector.data.ck_signed_application_form_attachment_status,
      ck_signed_application_form_attachment_comments:
        getAppSelector.data.ck_signed_application_form_attachment_comments,
      mk_master_agreeement_attachment_status:
        getAppSelector.data.mk_master_agreeement_attachment_status,
      mk_master_agreeement_attachment_comments:
        getAppSelector.data.mk_master_agreeement_attachment_comments,
      ck_master_agreeement_attachment_status:
        getAppSelector.data.ck_master_agreeement_attachment_status,
      ck_master_agreeement_attachment_comments:
        getAppSelector.data.ck_master_agreeement_attachment_comments,
    });
  }, [getAppSelector, reset]);

  const handleOtherDocsSubmit: SubmitHandler<BusinessDetailsType> = async (
    formData,
  ) => {
    // console.log(formData);
    setSubmitSpinner(true);
    setShowSaveAlert(false);
    let updateCustomerData = formData;
    dispatch(updateAppAction({ customerId, updateCustomerData })).then(
      (resp) => {
        // console.log(resp);
        setSubmitSpinner(false);
        setShowSaveAlert(true);
      },
    );
  };

  return (
    <>
      <DisplayBox display={showSaveAlert}>
        <AlertPopup
          message={"Details Saved Successfully!"}
          variant={"success"}
        />
      </DisplayBox>
      <Row className="text-center">
        <Col>
          <Button
            label="View Signed Application"
            variant="outline-primary"
            onClick={handleSignedAppClick}
          />
        </Col>
        <Col>
          {isCounterParty === false &&
            getAppSelector.data?.master_agreeement_attachment_ids[0] && (
              <Button
                label="View Master Agreement"
                variant="outline-primary"
                onClick={handleMasterAgreementClick}
              />
            )}
        </Col>
      </Row>
      <Row>
        <Row className="m-3">{titleText}</Row>
        <Col md={6}>
          <Container>
            {showSpinner ? (
              <Spinner variant="primary" animation="border" />
            ) : fileType === "pdf" ? (
              <iframe
                src={imageData}
                title="Document viewer"
                style={{ width: "550px", height: "550px" }}
              />
            ) : fileType === "img" ? (
              <Image
                src={imageData}
                style={{ width: "550px", border: "solid" }}
              />
            ) : null}
          </Container>
        </Col>
      </Row>
      <Container>
        <Row>
          <Col md="12">
            {titleText && (
              <SectionHeading text={`Document Verification:  ${titleText}`} />
            )}
          </Col>
        </Row>

        <Form onSubmit={handleSubmit(handleOtherDocsSubmit)}>
          {MAClicked && (
            <>
              <Row>
                <RadioButton
                  name={"mk_master_agreeement_attachment_status"}
                  label={"Maker Verification Status"}
                  options={[
                    { label: "Success", value: "Success" },
                    { label: "Failure", value: "Failure" },
                  ]}
                  register={register}
                  // error={errors.mk_master_agreeement_attachment_status?.message}
                  // required={userRole == "maker"}
                  // requiredMessage="Verification Status is required"
                  disabled={userRole !== "maker"}
                  onChange={(e) => setMakerVerStatus(e.target.value)}
                />
              </Row>
              <Row>
                <Input
                  label="Maker Verification Remarks"
                  name="mk_master_agreeement_attachment_comments"
                  register={register}
                  required={userRole == "maker" && makerVerStatus == "Failure"}
                  requiredMessage="Verification Remark is required"
                  error={
                    errors.mk_master_agreeement_attachment_comments?.message
                  }
                  disabled={userRole !== "maker"}
                  placeholder="Enter maker verification remarks"
                />
              </Row>
              <Row>
                <RadioButton
                  name={"ck_master_agreeement_attachment_status"}
                  label={"Checker Verification Status"}
                  options={[
                    { label: "Success", value: "Success" },
                    { label: "Failure", value: "Failure" },
                  ]}
                  register={register}
                  error={errors.mk_master_agreeement_attachment_status?.message}
                  required={userRole !== "maker"}
                  requiredMessage="Verification Status is required"
                  disabled={
                    userRole === "maker" ||
                    appStage !== "In Checker Verification"
                  }
                  onChange={(e) => setCheckerVerStatus(e.target.value)}
                />
              </Row>
              <Row>
                <Input
                  label="Checker Verification Remarks"
                  name="ck_master_agreeement_attachment_comments"
                  register={register}
                  required={
                    userRole !== "maker" && checkerVerStatus == "Failure"
                  }
                  // requiredMessage="Verification Remark is required"
                  error={
                    errors.ck_master_agreeement_attachment_comments?.message
                  }
                  disabled={
                    userRole === "maker" ||
                    appStage !== "In Checker Verification"
                  }
                  placeholder="Enter checker verification remarks"
                />
              </Row>
            </>
          )}{" "}
          {SAClicked && (
            <>
              <Row>
                <RadioButton
                  name={"mk_signed_application_form_attachment_status"}
                  label={"Maker Verification Status"}
                  options={[
                    { label: "Success", value: "Success" },
                    { label: "Failure", value: "Failure" },
                  ]}
                  required={userRole === "maker"}
                  requiredMessage="Verification status required"
                  register={register}
                  error={
                    errors.mk_signed_application_form_attachment_status?.message
                  }
                  disabled={userRole !== "maker"}
                  onChange={(e) => setMakerVerStatus(e.target.value)}
                />
              </Row>
              <Row>
                <Input
                  label="Maker Verification Remarks"
                  name="mk_signed_application_form_attachment_comments"
                  register={register}
                  disabled={userRole !== "maker"}
                  placeholder="Enter maker verification remarks"
                  required={userRole == "maker" && makerVerStatus == "Failure"}
                  requiredMessage="Verification Remark is required"
                  error={
                    errors.mk_signed_application_form_attachment_comments
                      ?.message
                  }
                />
              </Row>
              <Row>
                <RadioButton
                  name={"ck_signed_application_form_attachment_status"}
                  label={"Checker Verification Status"}
                  options={[
                    { label: "Success", value: "Success" },
                    { label: "Failure", value: "Failure" },
                  ]}
                  register={register}
                  error={
                    errors.ck_signed_application_form_attachment_status?.message
                  }
                  required={userRole !== "maker"}
                  requiredMessage="Verification Status is required"
                  disabled={
                    userRole === "maker" ||
                    appStage !== "In Checker Verification"
                  }
                  onChange={(e) => setCheckerVerStatus(e.target.value)}
                />
              </Row>
              <Row>
                <Input
                  label="Checker Verification Remarks"
                  name="ck_signed_application_form_attachment_comments"
                  register={register}
                  disabled={
                    userRole !== "checker" ||
                    appStage !== "In Checker Verification"
                  }
                  placeholder="Enter checker verification remarks"
                  required={
                    userRole !== "maker" && checkerVerStatus == "Failure"
                  }
                  error={
                    errors.ck_signed_application_form_attachment_comments
                      ?.message
                  }
                />
              </Row>
            </>
          )}
          <Row className="mt-2">
            {(appStage == "In Maker Verification" ||
              appStage == "In Checker Verification") && (
              <Col className="text-end">
                {titleText &&
                  (submitSpinner ? (
                    <Spinner variant="primary" animation="border" />
                  ) : (
                    <Button
                      type="submit"
                      label="Save Details"
                      disabled={
                        appStage === "Expired" ||
                        appStage === "Customer Registered" ||
                        appStage === "In Customer Registration" ||
                        (appStage == "In Checker Verification" &&
                          userRole == "maker") ||
                        (appStage == "In Maker Verification" &&
                          userRole == "checker")
                      }
                    />
                  ))}
              </Col>
            )}
          </Row>
        </Form>
      </Container>
    </>
  );
};

export default OtherDocsVerification;
